import { createFileRoute, notFound } from '@tanstack/react-router'
import CmsBlock from '@src/components/cms/CmsBlock'
import Request from '@src/services/api/Request'
import { routePageHead } from '@src/utils/routeHead'
import type { CategoryPageAttributes } from '@src/types/strapi'

export const Route = createFileRoute('/$category/$subCategory')({
  loader: async ({ params }) => {
    const categoryPage =
      (await Request.categories(params.category, params.subCategory)) || []
    const attributes =
      categoryPage.length > 0 ? (categoryPage[0]?.attributes ?? null) : null

    if (!attributes) {
      throw notFound()
    }

    return { categoryPage: attributes }
  },
  staleTime: 60_000,
  head: ({ loaderData }) =>
    routePageHead(loaderData?.categoryPage?.seo?.pageTitle),
  component: CategoryRoutePage,
})

function CategoryRoutePage() {
  const { categoryPage } = Route.useLoaderData() as {
    categoryPage: CategoryPageAttributes
  }

  return categoryPage?.components?.map(({ __component, ...props }, index) => (
    <CmsBlock
      component={__component}
      key={`${__component}-${String(props.id ?? 'block')}-${index}`}
      {...props}
    />
  ))
}
